import { TradeWay } from 'components/secondaryMarket/shared/SidePanel/TradeWay';
import { Price, StatusBottomBar, StatusContainerWithActionBar } from 'components/secondaryMarket/shared/status';
import { useIntl } from 'react-intl';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import type { TradeWay as TradeWayModel } from 'state/secondaryMarket/secondaryMarket.model';

interface TradingStatusProps {
  price: number;
  priceType: SecondaryPriceType;
  priceCurrency: string;
  tradeWay: TradeWayModel;
}

export function TradingStatus({ price, priceType, priceCurrency, tradeWay }: TradingStatusProps) {
  const { formatMessage } = useIntl();
  return (
    <>
      <StatusContainerWithActionBar className="w-100 d-flex flex-column mb-0 alert alert-discreet-warning rounded-top-3">
        <div className="d-flex flex-column">
          <TradeWay tradeWay={tradeWay} />
          {formatMessage({ id: 'secondaryMarket.sidePanel.label.settlementPrice' })}
        </div>
        <div className="px-0 py-2">
          <Price price={price} priceType={priceType} priceCurrency={priceCurrency} />
        </div>
      </StatusContainerWithActionBar>
      <div className="bg-warning bg-opacity-05" />
      <StatusBottomBar className="w-100 d-flex mb-0 alert alert-warning rounded-bottom-3">
        <div className="d-flex align-items-center">
          <em className="icon icon-sm">hourglass_empty</em>
          <span className="ms-2 flex-grow-1" data-e2e="secondary-side-panel-status">
            {formatMessage({
              id: 'secondaryMarket.sidePanel.label.awaitingConfirmation',
            })}
          </span>
        </div>
      </StatusBottomBar>
    </>
  );
}
